/**
 * Canonical Tykkit ticket theme palette (8 colors).
 * Shared by booking ticket cards, season-pass offer, loader, etc.
 */
export const TICKET_THEME = [
  { bg: "#79C9FF", text: "#051C5B" }, // blue
  { bg: "#FFB87A", text: "#5B2D05" }, // orange
  { bg: "#6AEAD7", text: "#0A486F" }, // teal
  { bg: "#FF8E99", text: "#92002D" }, // coral
  { bg: "#FF97D4", text: "#5B0559" }, // pink
  { bg: "#6AEA99", text: "#055B4A" }, // green
  { bg: "#E6EA6A", text: "#6F520A" }, // lime
  { bg: "#FE86FF", text: "#76148F" }, // magenta
];

export const getTicketTheme = (index = 0, id = "") => {
  if (typeof index === "number" && !Number.isNaN(index) && index >= 0) {
    return TICKET_THEME[index % TICKET_THEME.length];
  }
  if (id && typeof id === "string") {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
      hash = (hash + id.charCodeAt(i)) % TICKET_THEME.length;
    }
    return TICKET_THEME[hash];
  }
  return TICKET_THEME[0];
};

/** Blue-only highlight styles for the Season Pass offer card. */
export function getSeasonPassOfferStyle() {
  const blue = TICKET_THEME[0]; // #79C9FF / #051C5B

  return {
    gradient: `linear-gradient(105deg, #79C9FF 0%, #A8DBFF 45%, #D6EEFF 100%)`,
    border: blue.bg,
    text: blue.text,
    iconBg: "#ffffff",
    accent: blue,
  };
}
